// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3vfLzfVXCA4j6_dtFVV5y-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CountryProjectsList/CountryProjectsList.scss
// module id = 1591
// module chunks = 0